// Markdown tables in the chat bubbles (rendered by react-markdown).
//
// The first column of a chat table stays fixed while the table scrolls
// sideways (chatMessageStyles.js). When that column is only a RANK ("Rang",
// "Rank", "#" …) the fixed column says nothing on its own — the boss's
// feedback of 2026-10-26: "wenn Rang angezeigt wird, das nächste Feld auch".
// ChatTable marks such a table (data-sticky-pair) and measures the rank
// column, so the CSS can fix the second column right next to it. The width
// is measured, not guessed: a rank column is "1" … "40" one time and
// "Rang" with a long label the next.

import React, { useLayoutEffect, useRef } from 'react';

const RANK_HEADER = /^(rang|rank|#|nr\.?|no\.?|pos\.?|platz|position)$/i;

export function isRankHeader(text) {
  return RANK_HEADER.test((text || '').trim());
}

export function ChatTable({ node, ...props }) {
  const ref = useRef(null);

  // After every render: rows arrive while the answer streams, and the
  // rank column can widen with them.
  useLayoutEffect(() => {
    const table = ref.current;
    if (!table) return undefined;
    const headRow = table.querySelector('tr');
    const first = headRow ? headRow.children[0] : null;
    const update = () => {
      if (first && headRow.children.length > 2 && isRankHeader(first.textContent)) {
        table.setAttribute('data-sticky-pair', '');
        table.style.setProperty('--sticky-second-left', `${first.getBoundingClientRect().width}px`);
      } else {
        table.removeAttribute('data-sticky-pair');
      }
    };
    update();
    if (typeof ResizeObserver === 'undefined') return undefined;
    const observer = new ResizeObserver(update);
    observer.observe(table);
    if (first) observer.observe(first);
    return () => observer.disconnect();
  });

  return <table ref={ref} {...props} />;
}

// Pass to every chat's <ReactMarkdown components={…}>.
export const chatMarkdownComponents = { table: ChatTable };
